
import DashboardIcon from '@material-ui/icons/Dashboard';
import PeopleIcon from '@material-ui/icons/People';
import SettingsIcon from '@material-ui/icons/Settings';
import PersonIcon from '@material-ui/icons/Person';
import EventNoteIcon from '@material-ui/icons/EventNote';
import DescriptionIcon from '@material-ui/icons/Description';
import ReceiptIcon from '@material-ui/icons/Receipt';
import HelpIcon from '@material-ui/icons/Help';
import BuildIcon from '@material-ui/icons/Build';
import MessageIcon from '@material-ui/icons/Message';

const sidebarPages = [
  {
    pages: [
      {
        title: 'Dashboard',
        href: '/dashboard',
        icon: DashboardIcon
      },
      {
        title: 'Employees',
        icon: PeopleIcon,
        expandable: true,
        children: [
          {
            title: 'Manage',
            href: '/employees'
          },
          {
            title: 'Log Hours',
            href: '/employees/log-hours'
          },
          {
            title: 'Tasks',
            href: '/employees/tasks'
          },
          {
            title: 'Payroll',
            href: '/employees/payroll-list',
          },
          {
            title: "Today's Route",
            href: '/employees/today-route'
          },
        ]
      },
      {
        title: 'Customers',
        icon: PeopleIcon,
        expandable: true,
        children: [
          {
            title: 'Manage',
            href: '/customers/allcustomers',
          },
          {
            title: 'Billing',
            href: '/customers/billing',
          },
          {
            title: 'Bids to do',
            href: '/customers/bidtodo'
          },
          {
            title: 'Sales Follow Ups',
            href: '/customers/salefollowups',
          },
          {
            title: "Expiring Documents",
            href: '/customers/expiringdocuments',
          },
          {
            title: "Duplicates",
            href: '/customers/duplicate',
          },
          {
            title: "Missing Tax Groups",
            href: '/customers/missingtaxgroup',
          },
        ]
      },
      {
        title: 'Schedules',
        icon: EventNoteIcon,
        expandable: true,
        children: [
          {
            title: 'Manage',
            href: '/schedules',
          },
          {
            title: 'Recurring Routes',
            href: '/schedules/recurring-routes',
          }
        ]
      },
      {
        title: 'Job Completion',
        href: '/job-completion',
        icon: ReceiptIcon
      },
      {
        title: 'Reports',
        href: '/report',
        icon: DescriptionIcon
      },
      {
        title: 'Communication Center',
        icon: MessageIcon,
        expandable: true,
        children: [
          {
            title: 'Communications',
            href: '/communication-center'
          },
          {
            title: 'Advertising Export',
            href: '/communication-center/advertising'
          },
        ]
      },
      {
        title: 'Admin',
        icon: SettingsIcon,
        expandable: true,
        children: [
          {
            title: 'Manage',
            href: '/admin'
          },
          {
            title: 'Custom Forms',
            href: '/admin/custom-forms'
          },
          {
            title: 'Pricing',
            href: '/admin/pricing'
          },
          {
            title: 'Equipment',
            href: '/admin/equipment'
          },
          {
            title: 'Communications',
            href: '/admin/communications'
          },
          {
            title: 'Contracts & Forms',
            href: '/admin/contractsandforms'
          },
          {
            title: 'Tutorials',
            href: '/admin/tutorials'
          },
        ]
      },
    ]
  },
];

export const groupAdminSidebarPages = [
  {
    pages: [
      {
        title: 'Dashboard',
        href: '/dashboard',
        icon: DashboardIcon
      },
      {
        title: 'Employees',
        icon: PeopleIcon,
        expandable: true,
        children: [
          {
            title: 'Manage',
            href: '/employees'
          },
          {
            title: 'Log Hours',
            href: '/employees/log-hours'
          },
          {
            title: 'Tasks',
            href: '/employees/tasks'
          },
          {
            title: 'Payroll',
            href: '/employees/payroll-list',
          },
          {
            title: "Today's Route",
            href: '/employees/today-route'
          },
        ]
      },
      {
        title: 'Customers',
        icon: PeopleIcon,
        expandable: true,
        children: [
          {
            title: 'Manage',
            href: '/customers/allcustomers',
          },
          {
            title: 'Billing',
            href: '/customers/billing',
          },
          {
            title: 'Bids to do',
            href: '/customers/bidtodo'
          },
          {
            title: 'Sales Follow Ups',
            href: '/customers/salefollowups',
          },
          {
            title: "Expiring Documents",
            href: '/customers/expiringdocuments',
          },
          {
            title: "Duplicates",
            href: '/customers/duplicate',
          },
          {
            title: "Missing Tax Groups",
            href: '/customers/missingtaxgroup',
          },
        ]
      },
      {
        title: 'Schedules',
        icon: EventNoteIcon,
        expandable: true,
        children: [
          {
            title: 'Manage',
            href: '/schedules',
          },
          {
            title: 'Recurring Routes',
            href: '/schedules/recurring-routes',
          }
        ]
      },
      {
        title: 'Job Completion',
        href: '/job-completion',
        icon: ReceiptIcon
      },
      {
        title: 'Reports',
        href: '/report',
        icon: DescriptionIcon
      },
      {
        title: 'Communication Center',
        icon: MessageIcon,
        expandable: true,
        children: [
          {
            title: 'Communications',
            href: '/communication-center'
          },
          {
            title: 'Advertising Export',
            href: '/communication-center/advertising'
          },
        ]
      },
      {
        title: 'Admin',
        icon: SettingsIcon,
        expandable: true,
        children: [
          {
            title: 'Manage',
            href: '/admin'
          },
          {
            title: 'Custom Forms',
            href: '/admin/custom-forms'
          },
          {
            title: 'Pricing',
            href: '/admin/pricing'
          },
          {
            title: 'Equipment',
            href: '/admin/equipment'
          },
          {
            title: 'Communications',
            href: '/admin/communications'
          },
          {
            title: 'Contracts & Forms',
            href: '/admin/contractsandforms'
          },
          {
            title: 'Tutorials',
            href: '/admin/tutorials'
          },
          {
            title: 'Companies',
            href: '/super-admin/companies'
          },
        ]
      },
    ]
  },
];

export const superAdminSidebarPages = [
  {
    pages: [
      {
        title: 'Dashboard',
        href: '/dashboard',
        icon: DashboardIcon
      },
      {
        title: 'Employees',
        icon: PeopleIcon,
        expandable: true,
        children: [
          {
            title: 'Manage',
            href: '/employees'
          },
          {
            title: 'Log Hours',
            href: '/employees/log-hours'
          },
          {
            title: 'Tasks',
            href: '/employees/tasks'
          },
          {
            title: 'Payroll',
            href: '/employees/payroll-list',
          },
          {
            title: "Today's Route",
            href: '/employees/today-route'
          },
        ]
      },
      {
        title: 'Customers',
        icon: PeopleIcon,
        expandable: true,
        children: [
          {
            title: 'Manage',
            href: '/customers/allcustomers',
          },
          {
            title: 'Billing',
            href: '/customers/billing',
          },
          {
            title: 'Bids to do',
            href: '/customers/bidtodo'
          },
          {
            title: 'Sales Follow Ups',
            href: '/customers/salefollowups',
          },
          {
            title: "Expiring Documents",
            href: '/customers/expiringdocuments',
          },
          {
            title: "Duplicates",
            href: '/customers/duplicate',
          },
          {
            title: "Missing Tax Groups",
            href: '/customers/missingtaxgroup',
          },
        ]
      },
      {
        title: 'Schedules',
        icon: EventNoteIcon,
        expandable: true,
        children: [
          {
            title: 'Manage',
            href: '/schedules',
          },
          {
            title: 'Recurring Routes',
            href: '/schedules/recurring-routes',
          }
        ]
      },
      {
        title: 'Job Completion',
        href: '/job-completion',
        icon: ReceiptIcon
      },
      {
        title: 'Reports',
        href: '/report',
        icon: DescriptionIcon
      },
      {
        title: 'Communication Center',
        icon: MessageIcon,
        expandable: true,
        children: [
          {
            title: 'Communications',
            href: '/communication-center'
          },
          {
            title: 'Advertising Export',
            href: '/communication-center/advertising'
          },
        ]
      },
      {
        title: 'Admin',
        icon: SettingsIcon,
        expandable: true,
        children: [
          {
            title: 'Manage',
            href: '/admin'
          },
          {
            title: 'Custom Forms',
            href: '/admin/custom-forms'
          },
          {
            title: 'Pricing',
            href: '/admin/pricing'
          },
          {
            title: 'Equipment',
            href: '/admin/equipment'
          },
          {
            title: 'Communications',
            href: '/admin/communications'
          },
          {
            title: 'Contracts & Forms',
            href: '/admin/contractsandforms'
          },
          {
            title: 'Tutorials',
            href: '/admin/tutorials'
          },
        ]
      },
      {
        title: 'System Admin',
        icon: BuildIcon,
        expandable: true,
        children: [
          {
            title: 'Companies',
            href: '/super-admin/companies'
          },
          {
            title: 'Multi-Company Users',
            href: '/super-admin/multi-company-users'
          },
          {
            title: 'Company Groups',
            href: '/super-admin/company-groups'
          },
          {
            title: 'Email Export',
            href: '/super-admin/email-export'
          },
          {
            title: 'Customer Transfer',
            href: '/super-admin/customer-transfer',
          }
        ]
      },
    ]
  },
];

// CHANGING ANY OF THESE REQUIRES UPDATING LINES ~429 OF SIDEBARPAGES.JS
export const fieldTechnicianSidebarPages = [
  {
    pages: [
      {
        title: 'Employee',
        icon: PeopleIcon,
        expandable: false,
        children: [
          {
            title: 'Log Hours',
            href: '/employees/log-hours'
          },
          {
            title: 'Tasks',
            href: '/employees/tasks'
          },
          {
            title: 'Payroll',
            href: '/employees/payroll-detail',
          },
          {
            title: "Today's Route",
            href: '/employees/today-route'
          },
        ]
      },
    ]
  }
];

export const fieldTechnicianEstimatorSidebarPages = [
  {
    pages: [
      {
        title: 'Customers',
        icon: PeopleIcon,
        expandable: true,
        children: [
          {
            title: 'Manage',
            href: '/customers/allcustomers',
          },
          {
            title: 'Bids to do',
            href: '/customers/bidtodo'
          },
          {
            title: 'Sales Follow Ups',
            href: '/customers/salefollowups',
          },
        ]
      },
      {
        title: 'Employee',
        icon: PeopleIcon,
        expandable: false,
        children: [
          {
            title: 'Log Hours',
            href: '/employees/log-hours'
          },
          {
            title: 'Tasks',
            href: '/employees/tasks'
          },
          {
            title: 'Payroll',
            href: '/employees/payroll-detail',
          },
          {
            title: "Today's Route",
            href: '/employees/today-route'
          },
        ]
      },
    ]
  }
];

export const fieldTechnicianEstimatorScheduleSidebarPages = [
  {
    pages: [
      {
        title: 'Customers',
        icon: PersonIcon,
        expandable: true,
        children: [
          {
            title: 'Manage',
            href: '/customers/allcustomers',
          },
          {
            title: 'Bids to do',
            href: '/customers/bidtodo'
          },
          {
            title: 'Sales Follow Ups',
            href: '/customers/salefollowups',
          },
        ]
      },
      {
        title: 'Employee',
        icon: PeopleIcon,
        expandable: false,
        children: [
          {
            title: 'Log Hours',
            href: '/employees/log-hours'
          },
          {
            title: 'Tasks',
            href: '/employees/tasks'
          },
          {
            title: 'Payroll',
            href: '/employees/payroll-detail',
          },
          {
            title: "Today's Route",
            href: '/employees/today-route'
          }
        ]
      },
      {
        title: 'Schedules',
        icon: EventNoteIcon,
        expandable: true,
        children: [
          {
            title: 'Manage',
            href: '/schedules',
          },
          {
            title: 'Recurring Routes',
            href: '/schedules/recurring-routes',
          }
        ]
      }
    ]
  }];

export const sidebarPagesApplyFeatureFlag = [
  {
    pages: [
      {
        title: 'Dashboard',
        href: '/dashboard',
        icon: DashboardIcon
      },
      {
        title: 'Employees',
        icon: PeopleIcon,
        expandable: true,
        children: [
          {
            title: 'Manage',
            href: '/employees'
          },
          {
            title: 'Log Hours',
            href: '/employees/log-hours'
          },
          {
            title: 'Tasks',
            href: '/employees/tasks'
          },
          {
            title: 'Payroll',
            href: '/employees/payroll-list',
          },
          {
            title: "Today's Route",
            href: '/employees/today-route'
          },
        ]
      },
      {
        title: 'Customers',
        icon: PersonIcon,
        expandable: true,
        children: [
          {
            title: 'Manage',
            href: '/customers/allcustomers',
          },
          {
            title: 'Bids to do',
            href: '/customers/bidtodo'
          },
          {
            title: 'Sales Follow Ups',
            href: '/customers/salefollowups',
          },
          {
            title: "Expiring Documents",
            href: '/customers/expiringdocuments',
          },
          {
            title: "Duplicates",
            href: '/customers/duplicate',
          },
          {
            title: "Missing Tax Groups",
            href: '/customers/missingtaxgroup',
          },
        ]
      },
      {
        title: 'Schedules',
        icon: EventNoteIcon,
        expandable: true,
        children: [
          {
            title: 'Manage',
            href: '/schedules',
          },
          {
            title: 'Recurring Routes',
            href: '/schedules/recurring-routes',
          }
        ]
      },
      {
        title: 'Job Completion',
        href: '/job-completion',
        icon: ReceiptIcon
      },
      {
        title: 'Reports',
        href: '/report',
        icon: DescriptionIcon
      },
      {
        title: 'Communication Center',
        icon: MessageIcon,
        expandable: true,
        children: [
          {
            title: 'Communications',
            href: '/communication-center'
          },
          {
            title: 'Advertising Export',
            href: '/communication-center/advertising'
          },
        ]
      },
      {
        title: 'Admin',
        icon: SettingsIcon,
        expandable: true,
        children: [
          {
            title: 'Manage',
            href: '/admin'
          },
          {
            title: 'Custom Forms',
            href: '/admin/custom-forms'
          },
          {
            title: 'Pricing',
            href: '/admin/pricing'
          },
          {
            title: 'Equipment',
            href: '/admin/equipment'
          },
          {
            title: 'Communications',
            href: '/admin/communications'
          },
          {
            title: 'Contracts & Forms',
            href: '/admin/contractsandforms'
          },
          {
            title: 'Tutorials',
            href: '/admin/tutorials'
          }
        ]
      },
      // {
      //   title: 'Help',
      //   href: '/help',
      //   icon: HelpIcon
      // }
    ]
  },
];

export const superAdminSidebarPagesApplyFeatureFlag = [
  {
    pages: [
      {
        title: 'Dashboard',
        href: '/dashboard',
        icon: DashboardIcon
      },
      {
        title: 'Employees',
        icon: PeopleIcon,
        expandable: true,
        children: [
          {
            title: 'Manage',
            href: '/employees'
          },
          {
            title: 'Log Hours',
            href: '/employees/log-hours'
          },
          {
            title: 'Tasks',
            href: '/employees/tasks'
          },
          {
            title: 'Payroll',
            href: '/employees/payroll-list',
          },
          {
            title: "Today's Route",
            href: '/employees/today-route'
          },
        ]
      },
      {
        title: 'Customers',
        icon: PersonIcon,
        expandable: true,
        children: [
          {
            title: 'Manage',
            href: '/customers/allcustomers',
          },
          {
            title: 'Billing',
            href: '/customers/billing',
          },
          {
            title: 'Bids to do',
            href: '/customers/bidtodo'
          },
          {
            title: 'Sales Follow Ups',
            href: '/customers/salefollowups',
          },
          {
            title: "Expiring Documents",
            href: '/customers/expiringdocuments',
          },
          {
            title: "Duplicates",
            href: '/customers/duplicate',
          },
          {
            title: "Missing Tax Groups",
            href: '/customers/missingtaxgroup',
          },
        ]
      },
      {
        title: 'Schedules',
        icon: EventNoteIcon,
        expandable: true,
        children: [
          {
            title: 'Manage',
            href: '/schedules',
          },
          {
            title: 'Recurring Routes',
            href: '/schedules/recurring-routes',
          }
        ]
      },
      {
        title: 'Job Completion',
        href: '/job-completion',
        icon: ReceiptIcon
      },
      {
        title: 'Reports',
        href: '/report',
        icon: DescriptionIcon
      },
      {
        title: 'Communication Center',
        icon: MessageIcon,
        expandable: true,
        children: [
          {
            title: 'Communications',
            href: '/communication-center'
          },
          {
            title: 'Advertising Export',
            href: '/communication-center/advertising'
          },
        ]
      },
      {
        title: 'Admin',
        icon: SettingsIcon,
        expandable: true,
        children: [
          {
            title: 'Manage',
            href: '/admin'
          },
          {
            title: 'Custom Forms',
            href: '/admin/custom-forms'
          },
          {
            title: 'Pricing',
            href: '/admin/pricing'
          },
          {
            title: 'Equipment',
            href: '/admin/equipment'
          },
          {
            title: 'Communications',
            href: '/admin/communications'
          },
          {
            title: 'Contracts & Forms',
            href: '/admin/contractsandforms'
          },
          {
            title: 'Tutorials',
            href: '/admin/tutorials'
          }
        ]
      },
      {
        title: 'System Admin',
        icon: BuildIcon,
        expandable: true,
        children: [
          {
            title: 'Companies',
            href: '/super-admin/companies'
          },
          {
            title: 'Multi-Company Users',
            href: '/super-admin/multi-company-users'
          },
          {
            title: 'Company Groups',
            href: '/super-admin/company-groups'
          },
          {
            title: 'Email Export',
            href: '/super-admin/email-export'
          },
          {
            title: 'Customer Transfer',
            href: '/super-admin/customer-transfer',
          }
        ]
      },
      // {
      //   title: 'Help',
      //   href: '/help',
      //   icon: HelpIcon
      // }
    ]
  },
];

export default sidebarPages;
